import { DepartmentRole } from '../../common/department-role';

export interface IBearerTokenClaims {
    id: string;
    domainId: string;
    role: DepartmentRole;
    email: string;
    schedulableAssignmentPosts: string;
    schedulableVolunteerCongregations: string;
    enterableVolunteerCongregations: string;
    allowCheckIn: boolean;
    allowAssignmentPostEditing: boolean;
    tokenExpiration: number;
}


export class BearerTokenClaims implements IBearerTokenClaims {
    public id: string = '';
    public domainId: string = '';
    public role: DepartmentRole = DepartmentRole.Indeterminate;
    public email: string = '';
    public schedulableAssignmentPosts: string = '';
    public schedulableVolunteerCongregations: string = '';
    public enterableVolunteerCongregations: string = '';
    public allowCheckIn: boolean = false;
    public allowAssignmentPostEditing: boolean = false;
    public tokenExpiration: number = 0;
}


